module.exports = __webpack_public_path__ + "img/exostructure3.c8fe9ddf.png";